import { ApiDigitalService } from './api.digital.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

const routes = {
  orderListPackage: '/orders/list-package',
  allCities: '/country/province',
  saveOrder: '/orders',
  confirmOTP: '/orders/confirm-otp',
  resendConfirmOTP: '/orders/opt/generate',
  getOrderDetails: (phone: number, ordercode: string) => `/orders/tracking-and-detail?phone=${phone}&ordercode=${ordercode}`,
  confirmVTPay: (url: any) => `/orders/confirm-viettelpay/${url}`,
  allDistricts: (id: any) => `/country/district/${id}`,
  allWards: (id: any) => `/country/wards/${id}`
};

@Injectable({
  providedIn: 'root'
})
export class DigitalService {
  private myData = new Subject<string>();

  constructor(
    private apiDigitalService: ApiDigitalService
  ) { }

  getLstPackageDigital(data: any) {
    return this.apiDigitalService.post(routes.orderListPackage, data)
      .pipe(map(res => {
        return res;
      }));
  }

  getAllCity() {
    return this.apiDigitalService.get(routes.allCities)
      .pipe(map(res => {
        return res;
      }));
  }

  getAllDistricts(id: any) {
    return this.apiDigitalService.get(routes.allDistricts(id))
      .pipe(map(res => {
        return res;
      }));
  }

  getAllWard(id: any) {
    return this.apiDigitalService.get(routes.allWards(id))
      .pipe(map(res => {
        return res;
      }));
  }

  saveOrderService(model: any) {
    return this.apiDigitalService.post(routes.saveOrder, model)
      .pipe(map(res => {
        return res;
      }));
  }

  confirmOTP(model: any) {
    return this.apiDigitalService.post(routes.confirmOTP, model)
      .pipe(map(res => {
        return res;
      }));
  }

  resendConfirmationCode(model: any) {
    return this.apiDigitalService.post(routes.resendConfirmOTP, model)
      .pipe(map(res => {
        return res;
      }));
  }

  getOrderDetails(phone: number, orderCode: string) {
    return this.apiDigitalService.get(routes.getOrderDetails(phone, orderCode))
      .pipe(map(res => {
        return res;
      }));
  }

  confirmViettelpay(url: number) {
    return this.apiDigitalService.get(routes.confirmVTPay(url))
      .pipe(map(res => {
        return res;
      }));
  }

  //
  filterCertificateType(listData, FilterCtrl, filtered) {
    if (!listData) {
      return;
    }
    // get the search keyword
    let search = FilterCtrl.value;
    if (!search) {
      filtered.next(listData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    search = this.extractUnicode(search);

    // filter the certificateType
    filtered.next(
      listData.filter(listData => this.extractUnicode(listData.name).indexOf(search) > -1)
    );
  }

  extractUnicode(str: string) {
    if (!str) {
      return str;
    }
    let result = str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
    result = result.replace('đ', 'd');
    result = result.replace('Đ', 'd');
    return result;
  }


  //send data

  getData(): Observable<string> {
    return this.myData.asObservable();
  }

  updateData(data: any) {
    // console.log("updateData: ", data);
    this.myData.next(data);
  }

}
